import { render, staticRenderFns } from "./audioMessage.vue?vue&type=template&id=330c4e5f&scoped=true&"
import script from "./audioMessage.vue?vue&type=script&lang=js&"
export * from "./audioMessage.vue?vue&type=script&lang=js&"
import style0 from "./audioMessage.vue?vue&type=style&index=0&id=330c4e5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c4e5f",
  null
  
)

export default component.exports